// Keep custom collection/search badges in sync with current product availability.
(function zubazComingSoonGrid() {
  var families = ["GF1AOZ2TS11Z","FF1AOZ2TS11Z-DAC","COJAOZ3CD11Z","CB1AOZ3CS11Z","FA8AOZ3CS11Z","CH1TPZ2CB11Z","CH1OWZ2TB11Z","CF1TPZ2CF11Z","CF1OWZ2TF11Z","CS2AOZMCS11Z","CA8AOZ3CS11Z","CA8AOPOCS11Z","CA8AOCOCS11Z","CA8AOCACS11Z","GHHAOZ2TS11Z-AR83","GHHAOZ2TS11Z-BD20","GHHAOZ2TS11Z-BF04","GHHAOZ2TS11Z-BU54","GHHAOZ2TS11Z-DB09","GHHAOZ2TS11Z-DM13","GHHAOZ2TS11Z-JB36","GHHAOZ2TS11Z-JE07","GHHAOZ2TS11Z-JK12","GHHAOZ2TS11Z-JR80","GHHAOZ2TS11Z-LT56","GHHAOZ2TS11Z-MS50","GHHAOZ2TS11Z-RL52","GHHAOZ2TS11Z-RM84"];
  var nativeHoodieHandles = ["zubaz-nfl-legends-jerome-bettis-pittsburgh-steelers-mens-tonal-gameday-hoodie","zubaz-nfl-legends-john-elway-denver-broncos-mens-tonal-gameday-hoodie","zubaz-nfl-legends-jim-kelly-buffalo-bills-mens-tonal-gameday-hoodie","zubaz-nfl-legends-jerry-rice-san-francisco-49ers-mens-tonal-gameday-hoodie","zubaz-nfl-legends-lawrence-taylor-new-york-giants-mens-tonal-gameday-hoodie","zubaz-nfl-legends-mike-singletary-chicago-bears-mens-tonal-gameday-hoodie","zubaz-nfl-legends-ray-lewis-baltimore-ravens-mens-tonal-gameday-hoodie","zubaz-nfl-legends-randy-moss-minnesota-vikings-mens-tonal-gameday-hoodie"];
  var checked = new WeakSet();
  var requests = Object.create(null);
  var queue = [];
  var active = 0;
  var scheduled = false;
  function run() {
    while (active < 4 && queue.length) {
      active++;
      queue.shift()().then(function () { active--; run(); });
    }
  }
  function productInfo(handle) {
    if (!requests[handle]) {
      requests[handle] = new Promise(function (resolve) {
        queue.push(function () {
          return fetch('/products/' + encodeURIComponent(handle) + '.js', {credentials:'same-origin', cache:'no-store'})
            .then(function (response) { return response.ok ? response.json() : null; })
            .catch(function () { return null; })
            .then(resolve);
        });
        run();
      });
    }
    return requests[handle];
  }
  function scan() {
    scheduled = false;
    document.querySelectorAll('.zbz-bf-sold, .zbz-srch-sold, .product-item .label--subdued').forEach(function (badge) {
      if (checked.has(badge)) return;
      var link = badge.closest('a[href*="/products/"]');
      if (!link) {
        var card = badge.closest('.product-item');
        link = card && card.querySelector('a[href*="/products/"]');
        if (!link) return;
        var nativeHandle = new URL(link.href, location.href).pathname.split('/').pop();
        if (nativeHoodieHandles.indexOf(nativeHandle) === -1) return;
      }
      var match = new URL(link.href, location.href).pathname.match(/\/products\/([^/]+)/);
      if (!match) return;
      checked.add(badge);
      productInfo(decodeURIComponent(match[1])).then(function (product) {
        if (!product || !badge.isConnected) return;
        var eligible = (product.variants || []).some(function (variant) {
          var sku = String(variant.sku || '').trim();
          return families.some(function (family) { return sku === family || sku.indexOf(family + '-') === 0; });
        });
        if (!eligible) return;
        if (product.available) { badge.remove(); return; }
        badge.textContent = 'COMING SOON';
      });
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(scan);
  }
  function start() {
    document.querySelectorAll('body').forEach(function (root) {
      new MutationObserver(schedule).observe(root, {childList:true, subtree:true});
    });
    scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());

(function () {
  var FAMILIES = ["GF1AOZ2TS11Z","FF1AOZ2TS11Z-DAC","FHCRVZ3RF11Z","COJAOZ3CD11Z","CB1AOZ3CS11Z","FA8AOZ3CS11Z","CS2AOZMCS11Z","CA8AOCACS11Z","CA8AOCOCS11Z","CA8AOPOCS11Z","CA8AOZ3CS11Z","CH1TPZ2CB11Z","CH1OWZ2TB11Z","CF1TPZ2CF11Z","CF1OWZ2TF11Z","GHHAOZ2TS11Z-AR83","GHHAOZ2TS11Z-BD20","GHHAOZ2TS11Z-BF04","GHHAOZ2TS11Z-BU54","GHHAOZ2TS11Z-DB09","GHHAOZ2TS11Z-DM13","GHHAOZ2TS11Z-JB36","GHHAOZ2TS11Z-JE07","GHHAOZ2TS11Z-JK12","GHHAOZ2TS11Z-JR80","GHHAOZ2TS11Z-LT56","GHHAOZ2TS11Z-MS50","GHHAOZ2TS11Z-RL52","GHHAOZ2TS11Z-RM84"];
  var PRODUCT_LEVEL_FAMILIES = ["GF1AOZ2TS11Z","CH1TPZ2CB11Z","CH1OWZ2TB11Z","CF1TPZ2CF11Z","CF1OWZ2TF11Z","GHHAOZ2TS11Z-AR83","GHHAOZ2TS11Z-BD20","GHHAOZ2TS11Z-BF04","GHHAOZ2TS11Z-BU54","GHHAOZ2TS11Z-DB09","GHHAOZ2TS11Z-DM13","GHHAOZ2TS11Z-JB36","GHHAOZ2TS11Z-JE07","GHHAOZ2TS11Z-JK12","GHHAOZ2TS11Z-JR80","GHHAOZ2TS11Z-LT56","GHHAOZ2TS11Z-MS50","GHHAOZ2TS11Z-RL52","GHHAOZ2TS11Z-RM84"];
  var ID = 'zubaz-coming-soon-message';
  var zubazResolvedInventoryProduct = null;
  document.addEventListener('zubaz:coming-soon-inventory', function (event) {
    zubazResolvedInventoryProduct = event.detail;
    update();
  });
  function familyMatch(sku) {
    sku = String(sku || '').trim();
    return FAMILIES.some(function (family) { return sku.indexOf(family) === 0; });
  }
  function productLevelFamilyMatch(sku) {
    sku = String(sku || '').trim();
    return PRODUCT_LEVEL_FAMILIES.some(function (family) { return sku.indexOf(family) === 0; });
  }
  function productData() {
    if (zubazResolvedInventoryProduct) return zubazResolvedInventoryProduct;
    if (window.productData && Array.isArray(window.productData.variants)) return window.productData;
    var el = document.querySelector('[data-product-json]');
    if (el) { try { return JSON.parse(el.textContent); } catch (e) {} }
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var value = JSON.parse(scripts[i].textContent);
        if (value && Array.isArray(value.variants)) return value;
      } catch (e) {}
    }
    return window.meta && window.meta.product ? window.meta.product : null;
  }
  function selectedVariant(data) {
    var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = idInput && String(idInput.value || '');
    var variants = data && data.variants || [];
    return variants.find(function (v) { return String(v.id) === id; }) || variants[0] || null;
  }
  function skuAnchor() {
    var sku = document.querySelector('[data-product-sku], .product-meta__sku, .product__sku, .product-single__sku, [class*="sku"]');
    return sku && (sku.closest('.product-meta__reference') || sku);
  }
  function update() {
    var data = productData();
    var variant = selectedVariant(data);
    var sku = variant && variant.sku || (document.querySelector('[data-product-sku]') || {}).textContent || '';
    var addButton = document.querySelector('#AddToCart, form[action*="/cart/add"] button[type="submit"]');
    var buttonUnavailable = !!(addButton && (addButton.disabled || /sold out|unavailable/i.test(addButton.textContent || '')));
    var variantUnavailable = !!(variant && (variant.available === false || Number(variant.quantity) <= 0 || Number(variant.inventory_quantity) <= 0));
    var variants = data && data.variants || [];
    var productUnavailable = variants.length ? !variants.some(function (candidate) { return candidate.available === true; }) : (variantUnavailable || buttonUnavailable);
    var unavailable = productLevelFamilyMatch(sku) ? productUnavailable : (variantUnavailable || buttonUnavailable);
    var show = familyMatch(sku) && unavailable;
    var message = document.getElementById(ID);
    if (!show) { if (message) message.remove(); return; }
    var anchor = skuAnchor();
    if (!anchor) return;
    if (!message) {
      message = document.createElement('div');
      message.id = ID;
      message.textContent = 'Coming Soon!';
      message.style.cssText = 'margin-top:10px;font-weight:700;';
      anchor.insertAdjacentElement('afterend', message);
    }
  }
  document.addEventListener('change', function () { setTimeout(update, 0); });
  document.addEventListener('variant:change', update);
  new MutationObserver(update).observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['value']});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
}());

(function () {
  var handles = ["zubaz-nfl-legends-brian-dawkins-philadelphia-eagles-unisex-full-back-zebra-crewneck","zubaz-nfl-unisex-legends-90s-vintage-full-back-zebra-crewneck-brett-favre-green-bay-packers","zubaz-nfl-unisex-legends-90s-vintage-full-back-zebra-crewneck-brian-urlacher-chicago-bears","zubaz-nfl-unisex-legends-90s-vintage-full-back-zebra-crewneck-drew-brees-new-orleans-saints","zubaz-nfl-unisex-legends-90s-vintage-full-back-zebra-crewneck-dan-marino-miami-dolphins","zubaz-nfl-unisex-legends-90s-vintage-full-back-zebra-crewneck-jerome-bettis-pittsburgh-steelers","zubaz-nfl-unisex-legends-90s-vintage-full-back-zebra-crewneck-john-elway-denver-broncos","zubaz-nfl-unisex-legends-90s-vintage-full-back-zebra-crewneck-jim-kelly-buffalo-bills","zubaz-nfl-unisex-legends-90s-vintage-full-back-zebra-crewneck-randy-moss-minnesota-vikings","zubaz-nfl-legends-roger-staubach-dallas-cowboys-unisex-full-back-zebra-crewneck","zubaz-nfl-legends-steve-young-san-francisco-49ers-unisex-full-back-zebra-crewneck","zubaz-nfl-unisex-legends-90s-vintage-full-back-zebra-crewneck-andre-reed-buffalo-bills","zubaz-nfl-legends-joe-namath-new-york-jets-unisex-full-back-zebra-crewneck","zubaz-nfl-legends-jerry-rice-san-francisco-49ers-unisex-full-back-zebra-crewneck","zubaz-nfl-legends-lawrence-taylor-new-york-giants-unisex-full-back-zebra-crewneck","zubaz-nfl-legends-mike-ditka-chicago-bears-unisex-full-back-zebra-crewneck","zubaz-nfl-legends-mike-singletary-chicago-bears-unisex-full-back-zebra-crewneck","zubaz-nfl-legends-mike-vrabel-new-england-patriots-unisex-full-back-zebra-crewneck","zubaz-nfl-legends-ray-lewis-baltimore-ravens-unisex-full-back-zebra-crewneck", "zubaz-nfl-legends-andre-reed-buffalo-bills-mens-tonal-gameday-hoodie", "zubaz-nfl-legends-brian-dawkins-philadelphia-eagles-mens-tonal-gameday-hoodie", "zubaz-nfl-legends-brett-favre-green-bay-packers-mens-tonal-gameday-hoodie", "zubaz-nfl-legends-brian-urlacher-chicago-bears-mens-tonal-gameday-hoodie", "zubaz-nfl-legends-drew-brees-new-orleans-saints-mens-tonal-gameday-hoodie", "zubaz-nfl-legends-dan-marino-miami-dolphins-mens-tonal-gameday-hoodie"];
  function update() {
    var current = location.pathname.replace(/\/$/, '').split('/').pop();
    var onProduct = handles.indexOf(current) !== -1;
    if (onProduct) {
      document.querySelectorAll('.product-form button[type="submit"][disabled], .product-meta__label-list .label--subdued').forEach(function (node) {
        if (/^sold out$/i.test(node.textContent.trim())) node.textContent = 'Coming Soon';
      });
    }
    document.querySelectorAll('.zbz-pattern-pill').forEach(function (card) {
      var href = card.getAttribute('href');
      var handle = href ? href.split('?')[0].replace(/\/$/, '').split('/').pop() : current;
      if (handles.indexOf(handle) === -1) return;
      var status = card.querySelector('.zbz-next-pattern-stock');
      if (status && /^sold out$/i.test(status.textContent.trim())) status.textContent = 'Coming Soon';
    });
  }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; update(); });
  }
  new MutationObserver(schedule).observe(document.documentElement, {subtree:true, childList:true, characterData:true});
  document.addEventListener('variant:change', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
}());



// The eight approved Legends hoodies are Coming Soon only while every size is unavailable.
(function zubazLegendsHoodiesComingSoon() {
  var handles = ["zubaz-nfl-legends-jerome-bettis-pittsburgh-steelers-mens-tonal-gameday-hoodie","zubaz-nfl-legends-john-elway-denver-broncos-mens-tonal-gameday-hoodie","zubaz-nfl-legends-jim-kelly-buffalo-bills-mens-tonal-gameday-hoodie","zubaz-nfl-legends-jerry-rice-san-francisco-49ers-mens-tonal-gameday-hoodie","zubaz-nfl-legends-lawrence-taylor-new-york-giants-mens-tonal-gameday-hoodie","zubaz-nfl-legends-mike-singletary-chicago-bears-mens-tonal-gameday-hoodie","zubaz-nfl-legends-ray-lewis-baltimore-ravens-mens-tonal-gameday-hoodie","zubaz-nfl-legends-randy-moss-minnesota-vikings-mens-tonal-gameday-hoodie"];
  var current = location.pathname.replace(/\/$/, '').split('/').pop();
  if (handles.indexOf(current) === -1) return;
  var unavailable = null;
  var queued = false;
  function update() {
    queued = false;
    if (unavailable !== true) return;
    document.querySelectorAll('.product-form button[type="submit"][disabled], .product-meta__label-list .label--subdued').forEach(function (node) {
      if (/^sold out$/i.test(node.textContent.trim())) node.textContent = 'Coming Soon';
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }
  fetch('/products/' + encodeURIComponent(current) + '.js', {credentials:'same-origin', cache:'no-store'})
    .then(function (response) { return response.ok ? response.json() : null; })
    .then(function (product) {
      if (!product || !Array.isArray(product.variants)) return;
      unavailable = !product.variants.some(function (variant) { return variant.available === true; });
      document.dispatchEvent(new CustomEvent('zubaz:coming-soon-inventory', {detail:product}));
      schedule();
    }).catch(function () {});
  new MutationObserver(schedule).observe(document.documentElement, {subtree:true, childList:true, characterData:true});
  document.addEventListener('variant:change', schedule);
  document.addEventListener('variant:changed', schedule);
}());
